<template>
  <el-dialog :visible.sync="visibleSync" width="840px" :show-close="true" title="Danh sách phân loại giảng viên">
    <div class="row">
      <div class="col-6 mt-2">
        <label>Giảng viên</label>
        <el-input v-model="filters.keyword" placeholder="Mã, tên, số điện thoại" />
      </div>
      <div class="col-6 mt-2">
        <label>Phân loại</label>
        <el-select v-model="filters.categories" multiple clearable collapse-tags class="w-100"
          placeholder="Chọn phân loại">
          <el-option v-for="c in categoryOptions" :key="c.value" :label="c.label" :value="c.value" />
        </el-select>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-3">
      <button class="mt-2 btn btn-primary font-weight-bold mr-2" @click="openImport">
        <i class="fas fa-upload"></i> Import
      </button>
    </div>

    <div class="table-responsive mt-3">
      <table class="table table-hover table-bordered table-vertical-center b-table">
        <thead>
          <tr>
            <th class="min-w-150px">Mã giảng viên</th>
            <th class="min-w-250px">Họ tên giảng viên</th>
            <th class="min-w-150px">Phân loại</th>
          </tr>
        </thead>
        <tbody v-if="loading">
          <tr role="row" class="b-table-busy-slot">
            <td colspan="3" role="cell">
              <div class="text-primary my-2 text-center">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="row in rows" :key="row.teacher_code">
            <td>{{ row.id + 100000 }}</td>
            <td>{{ row.name }}</td>
            <td>{{ typeTeacherLabel(row.profile && row.profile.type_teacher) }}</td>
          </tr>
          <tr v-if="rows.length === 0">
            <td colspan="3" class="text-center">Không có dữ liệu</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <paginate v-model="page" :page-count="lastPage" :page-range="3" :margin-pages="1" :click-handler="onPage"
        :prev-text="'Trước'" :next-text="'Sau'" :container-class="'pagination b-pagination'"
        :pageLinkClass="'page-link'" :next-link-class="'next-link-item'" :prev-link-class="'prev-link-item'"
        :prev-class="'page-link'" :next-class="'page-link'" :page-class="'page-item'">
      </paginate>
    </div>

  </el-dialog>
</template>

<script>
import { INSPECTION_TEACHER_CATEGORY_LIST } from '@/core/services/store/inspection/inspection.module';

export default {
  name: 'TeacherCategoryModal',
  components: {},
  props: { visible: { type: Boolean, default: false } },
  data() {
    return {
      visibleSync: this.visible,
      filters: { keyword: '', categories: [] },
      categoryOptions: [
        { label: 'An toàn', value: 1 },
        { label: 'Rủi ro', value: 2 },
        { label: 'Rủi ro cao', value: 3 },
        { label: 'Chưa phân loại', value: 0 },
      ],
      loading: true,
      rows: [],
      page: 1,
      lastPage: 1,
    };
  },
  watch: {
    visible(v) { this.visibleSync = v; if (v) this.load(); },
    visibleSync(v) { this.$emit('update:visible', v); },
    filters: { handler() { this.page = 1; this.loadDebounced(); }, deep: true },
  },
  created() {
    this.load();
  },
  methods: {
    openImport() { this.visibleSync = false; this.$emit('open-import'); },
    onPage(p) { this.page = p; this.load(); },
    typeTeacherLabel(value) {
      const map = { 1: 'An toàn', 2: 'Rủi ro', 3: 'Rủi ro cao' };
      const key = Number(value);
      return map[key] || 'Chưa phân loại';
    },
    async load() {
      this.loading = true;
      const res = await this.$store.dispatch(INSPECTION_TEACHER_CATEGORY_LIST, {
        keyword: this.filters.keyword,
        'type_teachers': this.filters.categories,
        page: this.page,
        per_page: 12,
      });
      this.rows = res.data.data || [];
      this.lastPage = res.data.last_page || 1;
      this.loading = false;
    },
    reload() { this.load(); },
    loadDebounced: (() => { const _ = require('lodash'); return _.debounce(function () { this.load(); }, 250); })(),
  },
};
</script>

<style scoped></style>
